// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { type ReactElement, type ReactNode } from 'react';
import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

interface Props {
  readonly children: ReactNode;
  readonly anyOf: readonly string[];
}

// Faz 0 gecici route guard'i (allow-until-configured).
// RBAC seed edilene kadar acik: role bos/tanimsiz ise ya da admin-tier ise her sayfa serbest.
// Roller atanmaya baslayinca gercek kisitlama otomatik devreye girer.
// Backend DefaultPermissionEvaluator (permission yoksa Allow) ile simetrik.
const ADMIN_TIER = ['platform_admin', 'firm_admin', 'owner', 'admin'];

export function RequireRoles({ children, anyOf }: Props): ReactElement {
  const role = useAuthStore((s) => s.user?.role) ?? '';
  // Henuz rol seed edilmemis (bos) veya admin-tier → serbest
  if (role === '' || ADMIN_TIER.includes(role)) {
    return <>{children}</>;
  }
  if (anyOf.includes(role)) {
    return <>{children}</>;
  }
  return <NotAuthorized />;
}

export function NotAuthorized(): ReactElement {
  return (
    <div className="min-h-[calc(100vh-100px)] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-card border border-border rounded-2xl shadow-sm p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-rose-50 text-rose-600 mx-auto flex items-center justify-center mb-4">
          <Lock className="w-8 h-8" />
        </div>
        <h1 className="text-lg font-bold text-foreground mb-2">Yetkin Yok</h1>
        <p className="text-[14px] text-muted-foreground mb-5">
          Bu sayfayı görüntüleme yetkin bulunmuyor. Erişim gerekiyorsa yöneticinle iletişime geç.
        </p>
        <Link
          to="/admin/dashboard"
          className="inline-block px-4 py-2 text-[14px] font-semibold text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors"
        >
          Ana Panele Dön
        </Link>
      </div>
    </div>
  );
}
